import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["menu", "submenu", "toggleButton", "toggleIcon", "menuToolbar", "menuToolbarIcon"]
  connect() {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener("click", this.boundHandleClickOutside);
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside);
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.closeAll();
      this.closeMenuToolbar();
    }
  }
  toggle(event) {
    event.stopPropagation();
    // Determina si el menú actual está visible
    const isMenuVisible = !this.menuTarget.classList.contains("hidden");
    this.closeAll();

    // Si el menú actual no estaba visible, muéstralo
    if (!isMenuVisible) {
      this.menuTarget.classList.remove("hidden");

      // Asegúrate de que solo el menú principal cambie el color de fondo y el ícono
      if (this.hasToggleButtonTarget) {
        this.toggleButtonTarget.classList.add("bg-green-mga");
        this.toggleIconTarget.classList.add("rotate-180");
      }
    }
  }


  closeAll() {
    document.querySelectorAll("[data-dropdown-target='menu']").forEach((menu) => {
      menu.classList.add("hidden");
    });
    this.closeAllSubmenus();
    document.querySelectorAll("[data-dropdown-target='toggleButton']").forEach((btn) => {
      btn.classList.remove("bg-green-mga");
    });
    document.querySelectorAll("[data-dropdown-target='toggleIcon']").forEach((icon) => {
      icon.classList.remove("rotate-180");
    });
  }
  toggleMenuToolbar() {
    this.menuToolbarTarget.classList.toggle("hidden");
    this.menuToolbarIconTarget.classList.add("rotate-180");
  }

  closeMenuToolbar() {
    if (this.hasMenuToolbarTarget) {
      this.menuToolbarTarget.classList.add("hidden");
      this.menuToolbarIconTarget.classList.remove("rotate-180");
    }
  }

  toggleSubmenu(event) {
    event.preventDefault();
    event.stopPropagation();

    const submenu = event.currentTarget.nextElementSibling;
    if (!submenu) return;

    if (submenu.classList.contains('hidden')) {
      this.closeAllSubmenus();
      submenu.classList.remove('hidden');
    } else {
      submenu.classList.add('hidden');
    }
  }


  closeAllSubmenus() {
    document.querySelectorAll("[data-dropdown-target='submenu']").forEach((submenu) => {
      submenu.classList.add('hidden');
    });
  }

}
